import React from "react"
import { StaticQuery, graphql, Link } from "gatsby"
import { documentToReactComponents } from '@contentful/rich-text-react-renderer'
import { Row, Col } from "react-bootstrap"
import ScrollAnimation from "react-animate-on-scroll"
import OnlineOrderingImg from "../../images/online-ordering.svg"
import ConvenientBookingPageStyle from "./convenient-booking-page.module.scss"

const OnlineOrdering = () => (
    <StaticQuery query={graphql`
        query OnlineOrdering{
            contentfulConvenientBookingPage{
                convenientBookingReference{
                 sectionContent1{
                    subtitle{
                    subtitle
                    }
                    sectionParagraph{
                        json
                        }
                    }
                }
            }
        }
    `}
    render={data => (
    <div className={ConvenientBookingPageStyle.sectionDiv}>

        {/* Features Links */}
        <Row className={ConvenientBookingPageStyle.section1Features} id="parent-div">
            <Col xs={12}><h3 className={ConvenientBookingPageStyle.sectionTitle}>Website Features</h3></Col>
            <Col xs={6}>
                <div id="mobileWebFeatures">
                <ScrollAnimation animateIn="fadeInUp" duration={2} animateOnce={true} scrollableParentSelector='#parent-div'>
                <Link className={ConvenientBookingPageStyle.featuresBtn1} to="/essentials">The Essentials</Link>
                </ScrollAnimation>
                </div>
            </Col>
            <Col xs={6}>
                <div id="mobileWebFeatures">
                <ScrollAnimation animateIn="fadeInUp" duration={2} animateOnce={true} scrollableParentSelector='#parent-div'>
                <Link className={ConvenientBookingPageStyle.featuresBtn2} to="/mobile-first">Mobile First</Link>
                </ScrollAnimation>  
                </div>  
            </Col>
            <Col xs={6}>
                <div id="mobileWebFeatures">
                <ScrollAnimation animateIn="fadeInUp" duration={2} animateOnce={true} scrollableParentSelector='#parent-div'>
                <Link className={ConvenientBookingPageStyle.featuresBtn3} to="/engaging-menu">Engaging Menu</Link>
                </ScrollAnimation>
                </div>
            </Col>
            <Col xs={6}>
                <div id="mobileWebFeatures">
                 <ScrollAnimation animateIn="fadeInUp" duration={2} animateOnce={true} scrollableParentSelector='#parent-div'>
                <Link className={ConvenientBookingPageStyle.featuresBtn4} to="/convenient-booking">Convenient Booking</Link>
                </ScrollAnimation>
                </div>
            </Col>
        </Row>

        <Row className={ConvenientBookingPageStyle.mobileDesignDiv}>
            <Col className={ConvenientBookingPageStyle.mobileDesignCol1} md={7} sm={6}>
                <h3 className={ConvenientBookingPageStyle.sectionTitleLeftAlign}>{data.contentfulConvenientBookingPage.convenientBookingReference.sectionContent1.subtitle.subtitle}</h3>
                <div className={ConvenientBookingPageStyle.sectionDescriptionLeftAlign}>
                    {documentToReactComponents(data.contentfulConvenientBookingPage.convenientBookingReference.sectionContent1.sectionParagraph.json)}
                </div>
            </Col>
            <Col md={5} sm={6}>
                <ScrollAnimation animateIn="fadeInUp" duration={2} animateOnce={true}>
                    <OnlineOrderingImg className={ConvenientBookingPageStyle.mobileDesignImg} />
                </ScrollAnimation>
            </Col>
        </Row>
    </div>
    )}
    />
)

export default OnlineOrdering